/*
 * @Descripttion: 
 * @Author: qhx
 * @Date: 2025-03-07 14:08:40
 * @LastEditTime: 2025-04-15 16:00:05
 */
import React, { useState, useEffect} from "react";
import { Modal, Button, Input, message } from 'antd';
import { cancelOrder,orderCountTotal } from '@/api/personal-center';
import { cancelAfterSales } from '@/api/after-sales';
import { dispatch } from "@/redux/store";
import { setApplyCount } from '@/features/user/userSlice';
import './index.scss';
interface IProps {
  cancelFlag:boolean,
  setCancelFlag: any,
  orderId: string,
  setIsRefresh: any,
  cancelType: number
}
const OrderCancel: React.FC<IProps> = (props) => {
  const {cancelFlag,setCancelFlag,orderId,setIsRefresh,cancelType} = props;
  const reasonArr = cancelType===1? ['问题已自行解决','问题误判','改变主意','不符合售后条件']: ['不想买了','收货信息填写错误','商品错选','没用/少用优惠券'];
  const [otherFlag, setOtherFlag] = useState(false); // 其他原因显示
  const [reasonIndex, setReasonIndex] = useState(-1); // 原因选择
  const [reasonText, setReasonText] = useState('');
  useEffect(() => {
    setOtherFlag(false);
    setReasonIndex(-1);
    setReasonText('');
  },[cancelFlag])
  const reasonSelectFunc = (text:string,index:number) => {
    setOtherFlag(false);
    setReasonIndex(index);
    setReasonText(text);
  }
  const otherReasonSelect = () => {
    setOtherFlag(true);
    setReasonIndex(4);
    setReasonText('');
  }
  // 取消订单
  const orderCancelFunc = () => {
    if(orderId !== '') {
      if(reasonIndex === -1) {
        message.warning('请选择取消原因');
        return
      }
      if(reasonIndex===4 && reasonText.trim() === '') {
        message.warning('请输入其他原因');
        return
      }
      if(cancelType === 1) {
        cancelAfterSales({id:orderId,cancelReason:reasonText}).then((dRes:any) => {
          if(dRes.success) {
            message.success('取消成功！');
            setIsRefresh(true);
            cartCountFunc();
          }else {
            message.error(dRes.message);
          }
        })
      }else {
        cancelOrder(orderId,{reason:reasonText}).then((dRes:any) => {
          if(dRes.success) {
            message.success('取消成功！');
            setIsRefresh(true);
          }else {
            message.error(dRes.message);
          }
        })
      }
      
      setCancelFlag(false);
    }
  }
  const otherReasonInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setReasonText(value);
  };
  // 更新数量
  const cartCountFunc = () => {
    orderCountTotal().then((oRes:any) => {
      if(oRes.success) {
        dispatch(setApplyCount(oRes.obj?.apply??0));
      }
    })
  }
  return (
    <Modal
      title={cancelType === 0?'取消订单':"取消售后申请"}
      open={cancelFlag}
      onCancel={()=>setCancelFlag(false)}
      className="cancel-dialog-main"
      footer={false}
      width={900}
    >
      <div className="cancel-dialog-content">
        <p>{cancelType===1?'请选择取消售后申请的原因':'请选择取消订单原因'}</p>
        <div className="reason-list">
          {
            reasonArr.map((rData,index) => (
              <span key={index} className={`${reasonIndex===index && 'selected'}`} onClick={()=>reasonSelectFunc(rData,index)}>{rData}</span>
            ))
          }
        </div>
        <div className="reason-list other">
          <span className={`${reasonIndex===4 && 'selected'}`} onClick={()=> otherReasonSelect()}>其他原因</span>
          {
            otherFlag && 
            <Input placeholder="请输入原因" onChange={otherReasonInput} maxLength={50} />
          }
        </div>
        {
          cancelType === 0 &&
          <div className="reason-tips">温馨提示：订单取消成功后将无法恢复；优惠券将可能不再返还；支付优惠一并取消。</div>
        }
      </div>
      <div className="dialog-bottom">
        <Button className="submit-info" onClick={()=>setCancelFlag(false)}>再想想</Button>
        <Button className={`${reasonIndex!==-1&&'light'}`} onClick={()=>orderCancelFunc()}>确定取消</Button>
      </div>
    </Modal>
  )
}

export default OrderCancel;